import { styled } from "sharedUI/styles";

export const TeamInviteStyle = styled.div`
    display: flex;
    flex-direction: column;

    .title {
        font-size: 19px;
        font-weight: 800;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-bottom: 4px;
    }

    > .email-container {
        flex-grow: 1;

        .send-invite {
            display: flex;

            > .email-input {
                flex-grow: 1;
                margin-right: 8px;
            }

            > .email-send-button {
                margin: 16px 0px;
            }
        }

        > .invites {
            > .invite {
                display: flex;
                align-items: center;
                color: ${p => p.theme.n700A};
                font-size: 13px;
                height: 32px;

                > .invite-email-container {
                    display: flex;
                    flex-grow: 1;
                    align-items: center;

                    > .invite-photo {
                        color: ${p => p.theme.n500};
                        margin-right: 10px;
                    }
                }

                > .invite-actions {
                    display: flex;
                    color: ${p => p.theme.n600A};

                    > .invite-sent button {
                        color: ${p => p.theme.blue};
                        font-weight: 600;
                        align-self: stretch;
                        transition: all ${p => p.theme.transitionBase};
                        cursor: pointer;
                        opacity: 0.9;
                        padding-left: 16px;

                        :hover {
                            opacity: 1;
                        }
                    }
                }

                &.pending {
                    color: ${p => p.theme.n600A};
                }
            }

            .mems-user-photo {
                width: 20px;
                height: 20px;
                margin-right: 8px;
                margin-left: 4px;
                object-fit: cover;
                border-radius: 100px;
                background-color: ${p => p.theme.bgColorMedium};
            }

            .userLoading {
                height: 32px;
                background: ${p => p.theme.n600A};
            }
        }

        > .team-folder {
            display: flex;
            align-items: center;
            font-size: 13px;
            height: 32px;

            > .org-icon {
                margin-right: 4px;
            }

            > .org-name {
                color: ${p => p.theme.n700A};
                margin-right: 8px;
            }
        }

        > .manage-team {
            display: flex;
            justify-content: center;
            font-size: 12px;
            text-align: center;
            color: ${p => p.theme.iconBase};
            margin-top: 18px;

            > button {
                display: flex;
                align-items: center;
            }

            svg {
                margin-right: 4px;
            }
        }
    }

    .notice {
        color: ${p => p.theme.n700A};
        font-size: 11px;
        display: inline-flex;
        background: ${p => p.theme.n100};
        box-shadow: ${p => p.theme.shadow1};
        border-radius: 6px;
        padding: 12px 16px;
        margin-top: 18px;

        > div {
            height: 13.3px;
            width: 13.3px;
            margin: 0 12px 0 0;
        }

        a {
            color: ${p => p.theme.textAccent};
            text-decoration: none;
        }
    }
`;
